export default {
  overruleResult: 'Unieważnij wynik',
  overruleReason: 'Odrzuć powód',
  overruleResultLabel: 'Unieważnij wynik',
  valueSensorMeaningsPlaceholder: 'Wybierz sygnał główny',
  durationMeaningsPlaceholder: 'Wybierz sygnał trwania',
};
